"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardPanelProvider = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../helpers");
const PageWizardPanelContext_1 = require("../PageWizardPanelContext");
/**
 * @deprecated Use PageWizardPanelContainerProvider for Modal containerRef
 */
function PageWizardPanelProvider({ children }) {
    const [element, setPanel] = (0, react_1.useState)(null);
    const { getValue: getConfig, setValue: setConfig } = (0, helpers_1.useStateValue)({ isShrink: false });
    const deactivate = (0, react_1.useCallback)(() => {
        setPanel(null);
        setConfig({ isShrink: false });
    }, []);
    const activate = (0, react_1.useCallback)((el, config) => {
        setPanel(el);
        setConfig(Object.assign(Object.assign({}, config), { isShrink: !!(config === null || config === void 0 ? void 0 : config.isShrink) }));
    }, []);
    return react_1.default.createElement(PageWizardPanelContext_1.PageWizardPanelContext.Provider, {
        value: Object.assign({ deactivate, activate, element: element }, getConfig())
    }, children);
}
exports.PageWizardPanelProvider = PageWizardPanelProvider;
//# sourceMappingURL=PageWizardPanelProvider.js.map